module.exports = __webpack_public_path__ + "img/Gallery_2_27.876f943c.jpeg";